import script from "./CompanyManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyManagement.vue?vue&type=script&setup=true&lang=js"

import "./CompanyManagement.vue?vue&type=style&index=0&id=0f40836d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f40836d"]])

export default __exports__